import script from "./WinningModal.vue?vue&type=script&setup=true&lang=js"
export * from "./WinningModal.vue?vue&type=script&setup=true&lang=js"

import "./WinningModal.vue?vue&type=style&index=0&id=6e236fc2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e236fc2"]])

export default __exports__